import { PermissionLevel } from "./permissionNormalizer";

export const hasPermission = (
    permissions: Record<string, PermissionLevel>,
    permission: string,
    level: PermissionLevel
) => {
    const current =
        permissions[permission];

    if (!current || current === 'NONE') {
        return false;
    }

    if (level === 'READ') {
        return (
            current === 'READ' ||
            current === 'WRITE'
        );
    }

    return current === 'WRITE';
};